import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    rulesData: [],
    binsListByInstitution: [],
    countryList: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getAllRules = createAsyncThunk(
    "rule-engine-management/rules",
    async ({ user, pagination, orderBy, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;
            // const { sortColumn, isAsce } = orderBy;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getRuleListForMaker;

            // const apiURL = base + endpointpath + `${pageSize}/${currentPage}/${sortColumn}/${isAsce}`;
            const apiURL = base + endpointpath + `${pageSize}/${currentPage}`;

            const response = await axiosInstance.post(apiURL, search);

            if (response?.data?.responseStatus === 404) {
                toast.error(response?.data?.responseDescription);
            }

            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const getAllBinsByInstitution = createAsyncThunk(
    "rule-engine-management/bins-by-institution",
    async ({ user, id }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getBinRangesFromBin;

            const apiURL = base + endpointpath + id;

            const response = await axiosInstance.get(apiURL);

            return response?.data;
        } catch (error) {
            throw error.response;
        }
    }
);

export const postAddUpdateRuleEngine = createAsyncThunk(
    "rule-engine-management/add-update-rule-engine",
    async ({ user, body, update }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.saveRuleValuesByMaker;
            // const action = update ? 'edit' : 'add';

            // const apiURL = base + endpointpath + action;
            const apiURL = base + endpointpath;

            const method = update ? 'post' : 'post';
            const response = await axiosInstance[method](apiURL, body);

            if (response?.data?.responseCode === '400' || response?.data?.responseCode === '403') {
                toast.error(response?.data?.responseDescription);
                return { status: response?.data?.responseCode };
            }

            toast.success('Request has been initiated and sent to checker');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const getCountryList = createAsyncThunk(
    "rule-engine-management/country-list",
    async (user) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getallcurrency;

            const apiURL = base + endpointpath;

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const ruleEngineSlice = createSlice({
    name: "rule-engine",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET ALL RULES
            .addCase(getAllRules.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllRules.fulfilled, (state, action) => {
                const { resp, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.rulesData = resp || [];
                state.pagination = {
                    currentPage: currentPage || 0,
                    pageSize: pageSize || 20,
                    totalItem,
                    totalPages,
                };
            })
            .addCase(getAllRules.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // GET ALL BINS BY INSTITUTION
            .addCase(getAllBinsByInstitution.pending, (state) => {
                state.binsListByInstitution = [];
            })
            .addCase(getAllBinsByInstitution.fulfilled, (state, action) => {
                state.binsListByInstitution = action?.payload?.data ? action?.payload?.data?.filter(e => (e?.isActive && !e?.ruleConfigured))?.map((e) => ({ label: e?.bin, value: e?.id, scheme: { label: e?.schemeId?.name, value: e?.schemeId?.id, logo: e?.schemeId?.logoDataUri } })) : [];
            })
            .addCase(getAllBinsByInstitution.rejected, (state, action) => {
                state.binsListByInstitution = [];
            })

            // ADD UPDATE PARAMETER
            .addCase(postAddUpdateRuleEngine.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postAddUpdateRuleEngine.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAddUpdateRuleEngine.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Get All Countries for Currency
            .addCase(getCountryList.fulfilled, (state, action) => {
                state.countryList = action?.payload?.data || [];
            });
    },
});

export default ruleEngineSlice.reducer;